module.exports = __webpack_public_path__ + "static/media/as_item4_content.396e5086.png";